import { parseNumberByPrecision } from '@pascal/pascal-core';
import { mathConfig, mathJS } from './mathFormat';

export const allChipsTotal = (betsModel) => {
  return betsModel && betsModel?.betModel?.reduce((acc, cur) => {
    if (cur.includedBets) {
      cur.includedBets.forEach(item => acc = parseNumberByPrecision(1, +mathJS.format(+acc + +item.amount, mathConfig)));
    } else {
      acc = parseNumberByPrecision(1, +mathJS.format(+acc + +cur.bet.amount, mathConfig));
    }
    return acc;
  }, 0);
};